(() => {
  function initializeSearch(root = document) {
    root.querySelectorAll('[data-sg-search]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const chooser = form.querySelector('[data-sg-scope]');
      const fields = form.querySelector('[data-sg-search-fields]');
      const label = form.querySelector('.sg-search-family');
      chooser.hidden = false;
      form.addEventListener('submit', (event) => {
        if (form.querySelector('[name="q"]').value.trim()) return;
        const destination = chooser.options[chooser.selectedIndex].dataset.collectionUrl;
        if (!destination) return;
        event.preventDefault();
        window.location.assign(destination);
      });
      chooser.addEventListener('change', () => {
        const template = form.querySelector(`[data-sg-fields="${chooser.value}"]`);
        if (!template) return;
        fields.replaceChildren(template.content.cloneNode(true));
        label.textContent = chooser.options[chooser.selectedIndex].textContent;
      });
    });
  }

  function initializeNavigation() {
    const header = document.querySelector('[data-sg-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 'true';
    const shell = header.querySelector('[data-sg-navigation]');
    const toggle = header.querySelector('.sg-hamburger');
    const close = header.querySelector('[data-sg-close]');
    const overlay = header.querySelector('[data-sg-overlay]');
    const controls = Array.from(shell.querySelectorAll('[data-sg-disclosure]'));
    const mobile = window.matchMedia('(max-width: 989px)');
    let expanded = null;
    let mobileOpen = false;
    const panelFor = (control) => document.getElementById(control.getAttribute('aria-controls'));

    function closePanel(restoreFocus = false) {
      if (!expanded) return;
      const control = expanded;
      panelFor(control).hidden = true;
      control.setAttribute('aria-expanded', 'false');
      expanded = null;
      if (restoreFocus) control.focus();
    }

    function openPanel(control, focusFirst = false) {
      if (expanded !== control) closePanel();
      expanded = control;
      panelFor(control).hidden = false;
      control.setAttribute('aria-expanded', 'true');
      if (focusFirst) panelFor(control).querySelector('a')?.focus();
    }

    function closeMobile(restoreFocus = false) {
      closePanel();
      mobileOpen = false;
      toggle.setAttribute('aria-expanded', 'false');
      overlay.hidden = true;
      document.body.classList.remove('sg-no-scroll');
      shell.removeAttribute('aria-modal');
      shell.removeAttribute('role');
      if (mobile.matches) shell.hidden = true;
      if (restoreFocus) toggle.focus();
    }

    controls.forEach((control) => {
      control.hidden = false;
      panelFor(control).hidden = true;
      control.addEventListener('click', () => {
        if (expanded === control) closePanel();
        else openPanel(control);
      });
      control.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          openPanel(control, true);
        }
      });
    });

    toggle.addEventListener('click', () => {
      if (mobileOpen) closeMobile(true);
      else {
        mobileOpen = true;
        shell.hidden = false;
        overlay.hidden = false;
        shell.setAttribute('role', 'dialog');
        shell.setAttribute('aria-modal', 'true');
        toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('sg-no-scroll');
        close.focus();
      }
    });
    close.addEventListener('click', () => closeMobile(true));
    overlay.addEventListener('click', () => closeMobile(true));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (expanded) {
          event.preventDefault();
          closePanel(true);
        } else if (mobileOpen) {
          event.preventDefault();
          closeMobile(true);
        }
      }
      if (event.key === 'Tab' && mobileOpen) {
        const focusable = Array.from(shell.querySelectorAll('a[href],button:not([disabled])'))
          .filter((element) => element.getClientRects().length && !element.hidden);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    document.addEventListener('click', (event) => {
      if (header.contains(event.target)) return;
      closePanel(shell.contains(document.activeElement));
    });
    header.addEventListener('focusout', (event) => {
      if (event.relatedTarget && header.contains(event.relatedTarget)) return;
      // focusout can briefly report BODY during Tab; check after focus has settled.
      setTimeout(() => {
        if (!header.contains(document.activeElement) && !mobileOpen) closePanel();
      }, 0);
    });

    function updateMode() {
      const focusInShell = shell.contains(document.activeElement);
      const focusOnToggle = document.activeElement === toggle;
      closeMobile();
      toggle.hidden = !mobile.matches;
      close.hidden = !mobile.matches;
      shell.hidden = mobile.matches;
      if (mobile.matches && focusInShell) toggle.focus();
      else if (!mobile.matches && (focusOnToggle || focusInShell)) shell.querySelector('a').focus();
    }
    mobile.addEventListener('change', updateMode);
    updateMode();
  }

  function restoreEmptySearchFamily() {
    const emptySearch = document.querySelector('[data-sg-empty-search][data-sg-result-scope="unscoped"]');
    if (!emptySearch) return;
    const params = new URL(window.location.href).searchParams;
    const resources = params.getAll('type');
    const types = params.getAll('filter.p.product_type');
    if (resources.length !== 1 || resources[0] !== 'product' || !types.length) return;
    const families = ['temples', 'furniture', 'walls'];
    const matches = families.filter((family) => {
      const template = document.querySelector(`[data-sg-fields="${family}"]`);
      if (!template) return false;
      const allowedTypes = Array.from(template.content.querySelectorAll('[name="filter.p.product_type"]'))
        .map((input) => input.value).filter((value) => value && !value.startsWith('__sg_no_'));
      return types.every((value) => allowedTypes.includes(value));
    });
    if (matches.length !== 1) return;
    const scope = matches[0];
    const headings = { temples: emptySearch.dataset.sgTempleHeading, furniture: emptySearch.dataset.sgFurnitureHeading, walls: emptySearch.dataset.sgWallsHeading };
    const heading = headings[scope];
    document.querySelectorAll('[data-sg-search]').forEach((form) => {
      const chooser = form.querySelector('[data-sg-scope]');
      chooser.value = scope;
      chooser.dispatchEvent(new Event('change'));
      form.querySelectorAll('[data-sg-search-fields] [name="filter.p.product_type"]').forEach((input) => {
        if (!types.includes(input.value)) input.remove();
      });
      form.querySelector('.sg-search-family').textContent = heading;
    });
    emptySearch.querySelector('[data-sg-search-heading]').textContent = heading;
    emptySearch.querySelector('[data-sg-scope-help]').hidden = true;
    emptySearch.querySelectorAll('[data-sg-family-link]').forEach((link) => {
      if (link.dataset.sgFamilyLink === scope) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    if (['filter.v.availability', 'filter.v.price.gte', 'filter.v.price.lte'].some((key) => params.get(key))) {
      const reset = emptySearch.querySelector('[data-sg-zero-reset]');
      const url = new URL(document.querySelector('[data-sg-search]').action);
      url.search = '';
      url.searchParams.set('q', params.get('q') || '');
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      types.forEach((type) => url.searchParams.append('filter.p.product_type', type));
      reset.href = url.href;
      reset.hidden = false;
    }
  }

  initializeSearch();
  initializeNavigation();
  restoreEmptySearchFamily();
  document.addEventListener('shopify:section:load', (event) => {
    initializeSearch(event.target);
    initializeNavigation();
    restoreEmptySearchFamily();
  });
})();
